<template>
<div>
    <div class='card todo'>
         <div class='card-body'>
            <h4 class='card-title'>ToDo</h4>
            <p>
                <p-button nativeType="submit" type="success" outline size="sm"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>
            </p>
            <p>
                <b-button type="submit" class="btn-success btn-report">
					<b-icon icon="arrow-clockwise" scale="1.2"></b-icon>
					{{ $t('report.generate') }}
				</b-button>
            </p>

            <p>
                <button type="submit" class="btn-x ok" @click="onSubmit">
					<b-icon icon="check"></b-icon>
					<span>{{ $t('button.save') }}</span>
				</button>

                <button type="submit" class="btn-x rm">
					<b-icon icon="x"></b-icon>
					<span>{{ $t('button.remove') }}</span>
				</button>

                 <button type="submit" class="btn-x">
					<b-icon icon="arrow-clockwise"></b-icon>
					<span>{{ $t('report.generate') }}</span>
				</button>

            </p>

            

            <div style="width: 200px">
                <fg-input name="Testi"
                  placeholder="Testi" 
                  addon-left-icon="nc-icon nc-simple-remove">
                </fg-input>

                <fg-input name="Testi"
                  placeholder="Testi" 
                  addon-right-icon="nc-icon nc-alert-circle-i">
                </fg-input>

                <hr>
                
                <b-form-input id="input-valid" :state="true" placeholder="Valid input"></b-form-input>
                <br>
                <b-form-input id="input-invalid" :state="false" placeholder="Invalid input"></b-form-input>
                <br>

                <b-input-group  class="mb-2">
                    <b-input-group-prepend is-text><b-icon icon="exclamation-triangle" variant="danger"></b-icon></b-input-group-prepend>
                    <b-form-input type="search" placeholder="Search..."></b-form-input>
                </b-input-group>

            </div>
            

         </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        disabled: {type: Boolean, default: false}
    },
    methods: {
        onSubmit() {
            alert("submit");
        }
    }
}
</script>


<style scoped lang="scss">

#terminal-displays {
    /* height: 620px; */
}

.displays {
    display: flex;
    /* justify-content: space-between; */

    justify-content: center;
    flex-wrap: wrap;
   
    margin: 20px 0px;
/*
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
    */
}

.display {
    margin: 5px;
}

.d-header {
    border: 3px solid #000;
    border-bottom-width: 0;

    padding: 0 5px;

    /*text-align: center;*/
    font-weight: bold;

    div {
        display: inline-block;
    }

    .id {
        float: right;
    }
}

.d-screen {
    width: 180px;
    height: 100px;
    border: 3px solid #000;

    
    text-align: center;
    font-weight: bold;

    background: linear-gradient(-45deg, #788cff, #b4c8ff);
}



#transfers {
    height: 400px;
}

#infos {
    height: 400px;
}

</style>